/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { anchorDef, elementDef } from './element';
export { clearOverrides, createNgModuleFactory, overrideComponentView, overrideProvider } from './entrypoint';
export { ngContentDef } from './ng_content';
export { moduleDef, moduleProvideDef } from './ng_module';
export { directiveDef, pipeDef, providerDef } from './provider';
export { pureArrayDef, pureObjectDef, purePipeDef } from './pure_expression';
export { queryDef } from './query';
export { ViewRef_, createComponentFactory, getComponentViewDefinitionFactory, nodeValue } from './refs';
export { initServicesIfNeeded } from './services';
export { textDef } from './text';
export { EMPTY_ARRAY, EMPTY_MAP, createRendererType2, elementEventFullName, inlineInterpolate, interpolate, rootRenderNodes, tokenKey, unwrapValue } from './util';
export { viewDef } from './view';
export { attachEmbeddedView, detachEmbeddedView, moveEmbeddedView } from './view_attach';
export { shiftInitState, shouldCallLifecycleInitHook, NodeData, asTextData, asElementData, asProviderData, asPureExpressionData, asQueryList, DebugContext, Services } from './types';
//# sourceMappingURL=index.js.map